import { useEffect, useMemo, useRef, useState } from 'react';
import { Field } from './Fields';

// Curso da carteirinha: combobox com lista de sugestões que TAMBÉM aceita texto
// livre (curso fora da lista). Espelha o CursoComboBox do UEN, adaptado ao tema
// do portal (input .pinput + tokens --p-*). O <datalist> nativo foi evitado de
// propósito — não dá pra estilizar o painel.
export const CURSOS = [
    'Administração', 'Agronomia', 'Análise e Desenvolvimento de Sistemas',
    'Arquitetura e Urbanismo', 'Biomedicina', 'Ciência da Computação',
    'Ciências Biológicas', 'Ciências Contábeis', 'Ciências Econômicas',
    'Design Gráfico', 'Direito', 'Educação Física', 'Enfermagem',
    'Engenharia Ambiental', 'Engenharia Civil', 'Engenharia de Produção',
    'Engenharia de Software', 'Engenharia Elétrica', 'Engenharia Mecânica',
    'Engenharia Química', 'Estética e Cosmética', 'Farmácia', 'Filosofia',
    'Física', 'Fisioterapia', 'Fonoaudiologia', 'Gastronomia', 'Geografia',
    'Gestão de Recursos Humanos', 'História', 'Jornalismo', 'Letras', 'Logística',
    'Marketing', 'Matemática', 'Medicina', 'Medicina Veterinária', 'Nutrição',
    'Odontologia', 'Pedagogia', 'Psicologia', 'Publicidade e Propaganda',
    'Química', 'Radiologia', 'Redes de Computadores', 'Relações Internacionais',
    'Serviço Social', 'Sistemas de Informação',
    'Técnico em Administração', 'Técnico em Edificações', 'Técnico em Enfermagem',
    'Técnico em Informática', 'Técnico em Segurança do Trabalho',
];

export default function CursoComboBox({
    id = 'curso',
    label = 'Curso',
    value,
    onChange,
    placeholder = 'Selecione ou digite o curso',
    list = CURSOS,
}) {
    const [open, setOpen] = useState(false);
    const [hover, setHover] = useState(null);
    const wrapRef = useRef(null);

    const filtrados = useMemo(() => {
        const v = (value || '').toLowerCase().trim();
        if (!v) return list;
        return list.filter((c) => c.toLowerCase().includes(v));
    }, [value, list]);

    useEffect(() => {
        if (!open) return;
        const onClick = (e) => { if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false); };
        document.addEventListener('mousedown', onClick);
        return () => document.removeEventListener('mousedown', onClick);
    }, [open]);

    const escolher = (c) => { onChange(c); setOpen(false); };

    return (
        <Field label={label} htmlFor={id}>
            <div ref={wrapRef} style={{ position: 'relative' }}>
                <input
                    id={id}
                    type="text"
                    className="pinput"
                    value={value || ''}
                    placeholder={placeholder}
                    autoComplete="off"
                    onChange={(e) => { onChange(e.target.value); setOpen(true); }}
                    onFocus={() => setOpen(true)}
                />
                {open && filtrados.length > 0 && (
                    <ul style={panelStyle}>
                        {filtrados.map((c) => (
                            <li
                                key={c}
                                onMouseDown={(e) => { e.preventDefault(); escolher(c); }}
                                onMouseEnter={() => setHover(c)}
                                onMouseLeave={() => setHover(null)}
                                style={{ ...itemStyle, background: hover === c ? 'var(--p-surface-hover, #eef3ef)' : 'transparent' }}
                            >
                                {c}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </Field>
    );
}

const panelStyle = {
    position: 'absolute', top: 'calc(100% + 4px)', left: 0, right: 0, margin: 0, padding: 4,
    listStyle: 'none', maxHeight: 220, overflowY: 'auto',
    background: 'var(--p-surface, #fff)', border: '1px solid var(--p-border, #e5e7eb)',
    borderRadius: 10, boxShadow: 'var(--p-shadow-md, 0 8px 24px rgba(0,0,0,.08))', zIndex: 30,
};

const itemStyle = { padding: '9px 11px', cursor: 'pointer', borderRadius: 8, fontSize: 14.5, color: 'var(--p-text, #111827)' };
